import React from 'react';
import get from 'lodash/get';
import { ScorePlayerCell } from 'components/scores';

const LeaderboardCellScores = ({ scoringCourseRound, scoringPlayerRound }) => {
    return (
        <div className={'leaderboard__cell leaderboard__cell--scores'}>
            {
                scoringCourseRound.holePars.map((holePar, i) => {
                    const playerPar = get(scoringPlayerRound, `info[${i}].playerPar`) || null;

                    return <ScorePlayerCell
                        childCss='leaderboard__score-cell'
                        key={holePar.holeId}
                        holePar={holePar.par}
                        playerPar={playerPar}
                    />;
                })
            }
        </div>
    );
};

export default LeaderboardCellScores;
